/**
 * BrandLogoMark — Reusable flower symbol logo component
 * Used in all non-header locations (page heroes, footers, sidebars, etc.)
 * Consistent sizing, styling, and optional effects
 */

interface BrandLogoMarkProps {
  size?: "sm" | "md" | "lg";
  withGlow?: boolean;
  className?: string;
}

export default function BrandLogoMark({ size = "md", withGlow = false, className = "" }: BrandLogoMarkProps) {
  // Define size mappings
  const sizeMap = {
    sm: 52,
    md: 80,
    lg: 120,
  };

  const width = sizeMap[size];

  const style: React.CSSProperties = {
    width,
    height: "auto",
    objectFit: "contain",
    ...(withGlow && {
      filter: "drop-shadow(0 0 18px rgba(0,212,255,0.55))",
    }),
  };

  return (
    <div style={{ display: "flex", justifyContent: "center", marginBottom: "1rem" }} className={className}>
      <img src="/media/brand/chi-flower-symbol.png" alt="The Chi Alliance" style={style} />
    </div>
  );
}
